import React from 'react';
import PropTypes from 'prop-types';
import {Checkbox, Grid} from "@mui/material";
import {greyishBlue100, greyishBlue600} from "../../../../assets/jss/main";
import {ArrowForward, ImageSharp} from "@mui/icons-material";
import {styled} from "@mui/material/styles";
import store from "../../../../store";
import Badge from "../../../../components/Badge";
import {FormattedMessage} from "react-intl";
import {LineItemStatusBadgeStyle} from "./ArticleRow/components/LineItemStatusBadgeStyle";
import {BpCheckedIcon, BpIcon} from "../../../../components/WMS/AccordionShipment/checkboxIcons";

TobeScannedArticle.propTypes = {
    article: PropTypes.object.isRequired,
    selectItem: PropTypes.func,
    displayOldStatus: PropTypes.bool
};

const imageFrame = {
    width: '48px',
    height: '64px',
    boxSizing: 'border-box',
    borderRadius: '8px',
    border: `1px solid ${greyishBlue100}`
};

const StyledImage = styled('img')({
    ...imageFrame,
    objectFit: 'cover',
    verticalAlign: 'middle'
});

function TobeScannedArticle({article, selectItem, displayOldStatus = false}) {

    function getArticleBranAndOptions() {
        const retailerOptionValue = article.variation?.retailerOptionValues ?? []
        const locale = store.getState().currentOrganization?.retrieved?.defaultLocale;
        return `${article.variation.product.brand.name ?? 'N/A'} • ${getOptionValueByCode(retailerOptionValue, 'Size',locale) ?? 'N/A'} • ${getOptionValueByCode(retailerOptionValue, 'Color',locale) ?? 'N/A'}`
    }

    function getOptionValueByCode(retailerOptionValues, type, locale) {
        const match = retailerOptionValues?.find(rov => rov.option?.type === type);
        if (!match) return null;
        return match.translations?.[locale]?.name ?? null;
    }

    return (
        <Grid
            container
            justifyContent={'space-between'}
            flexWrap={'nowrap'}
            sx={{
                borderBottom: '1px solid',
                borderColor: greyishBlue100
            }}
            alignItems={'center'}
        >
            <Grid
                container
                sx={{
                    margin: '8px 0px',
                    fontSize: '14px'
                }}
                flexWrap={'nowrap'}
                alignItems={'center'}
            >
                <Checkbox
                    icon={<BpIcon/>}
                    checkedIcon={<BpCheckedIcon/>}
                    onChange={(event) => selectItem(article, event.target.checked)}
                />
                {article.pictures.length === 0 ?
                    <ImageSharp color={"disabled"} sx={{fontSize: '50px'}}/>
                    :
                    <StyledImage src={article.pictures[0]} alt={article.name}/>
                }

                <Grid
                    container
                    direction={"column"}
                    sx={{marginLeft: '8px'}}
                >
                    <span style={{fontWeight: 600}}>{article.name}</span>
                    <span style={{color: greyishBlue600}}>{getArticleBranAndOptions()}</span>
                    <span>{article.variation.barcode}</span>
                </Grid>
            </Grid>

            {displayOldStatus ? (
                <Grid container sx={{marginRight: '8px'}} justifyContent={'end'} alignItems={'center'}>
                    <Badge
                        label={<FormattedMessage id={"retailer.picking.itemList.status."+article.oldStatus}/>}
                        color={"statusColor"}
                        border={true}
                        themeExtension={LineItemStatusBadgeStyle[article.oldStatus]}
                    />
                    <ArrowForward sx={{marginX: '8px', width: '20px', height: '20px', color: greyishBlue600}}/>
                    <Badge
                        label={<FormattedMessage id={"retailer.picking.itemList.status."+article.status}/>}
                        color={"statusColor"}
                        border={true}
                        themeExtension={LineItemStatusBadgeStyle[article.status]}
                    />
                </Grid>
            ) : (
                <Grid item sx={{marginRight: '8px'}}>
                    <Badge
                        label={<FormattedMessage id={"retailer.picking.itemList.status."+article.status}/>}
                        color={"statusColor"}
                        border={true}
                        themeExtension={LineItemStatusBadgeStyle[article.status]}
                    />
                </Grid>
            )}

        </Grid>
    );
}

export default TobeScannedArticle;